@if (open) {
  <div class="astral-dialog__backdrop" (click)="handleBackdropClick($event)">
    <section
      class="astral-dialog"
      [class.astral-dialog--suspended]="suspended"
      [class.astral-dialog--small]="size === 'small'"
      [class.astral-dialog--large]="size === 'large'"
      [class.astral-dialog--modal]="variant === 'modal'"
      [class.astral-dialog--prompt]="variant === 'prompt'"
      [class.astral-dialog--news]="variant === 'news'"
      [class.astral-dialog--news-urgent]="variant === 'news' && newsEmphasis === 'urgent'"
      [class.astral-dialog--news-preserve-aspect-ratio]="variant === 'news' && preserveNewsAspectRatio"
      [cdkTrapFocus]="!suspended"
      [cdkTrapFocusAutoCapture]="!suspended"
      [attr.aria-describedby]="contentId"
      [attr.aria-label]="hasTitle ? null : (resolvedAriaLabel | translate)"
      [attr.aria-labelledby]="hasTitle ? titleId : null"
      [attr.aria-modal]="true"
      [attr.role]="resolvedRole"
      [attr.aria-hidden]="suspended ? 'true' : null"
      [attr.inert]="suspended ? '' : null"
      tabindex="-1"
      (keydown)="handleKeydown($event)"
    >
      @if (variant === 'news') {
        <div class="astral-dialog__media">
          <ng-content select="[astralDialogMedia]"></ng-content>
        </div>
        <div class="astral-dialog__main">
          <div class="astral-dialog__message">
            <div class="astral-dialog__message-inner">
              <ng-content select="[astralDialogNewsBadge]"></ng-content>
              <ng-container [ngTemplateOutlet]="dialogHeader"></ng-container>
              <ng-container [ngTemplateOutlet]="dialogContent"></ng-container>
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="dialogActions"></ng-container>
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="dialogHeader"></ng-container>
        <ng-container [ngTemplateOutlet]="dialogContent"></ng-container>
        <ng-container [ngTemplateOutlet]="dialogActions"></ng-container>
      }
    </section>
  </div>
}

<ng-template #dialogHeader>
  @if (hasTitle || showCloseButton) {
    <header class="astral-dialog__header">
      <div class="astral-dialog__heading">
        <div class="astral-dialog__icon" aria-hidden="true">
          <ng-content select="[astralDialogIcon]"></ng-content>
        </div>
        @if (hasTitle) {
          <h2 class="astral-dialog__title" [attr.id]="titleId">{{ resolvedTitle | translate }}</h2>
        }
      </div>

      @if (showCloseButton) {
        <astral-button
          class="astral-dialog__close"
          ariaLabel="CLOSE_BTN"
          [icon]="closeIcon"
          size="extra-small"
          type="button"
          variant="link-button"
          (click)="requestClose()"
        ></astral-button>
      }
      <div class="astral-dialog__header-content"><ng-content select="[astralDialogHeaderContent]"></ng-content></div>
    </header>
  }
</ng-template>

<ng-template #dialogContent>
  <div class="astral-dialog__content" [attr.id]="contentId">
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #dialogActions>
  <footer class="astral-dialog__actions">
    <ng-content select="[astralDialogActions]"></ng-content>
  </footer>
</ng-template>
